import { FormType } from "@simplyk/common";

import { DonationFormSkeleton } from "./DonationFormSkeleton";
import { TicketingSkeleton } from "./TicketingSkeleton";

import { DashboardZeffyLoader } from "@/dashboard-design-system/ZeffyLoader/DashboardZeffyLoader";

interface FormSkeletonProps {
  formType: FormType;
}

export const FormSkeleton = ({ formType }: FormSkeletonProps) => {
  if (formType === FormType.DonationForm) {
    return <DonationFormSkeleton />;
  }

  if (formType === FormType.Ticketing) {
    return <TicketingSkeleton />;
  }

  return <DashboardZeffyLoader />;
};
